<template>
  <!-- carte fichier du design system (Attachment) : ouvrir au clic, bouton telecharger a droite -->
  <div
    data-slot="attachment"
    data-test-id="message-file"
    class="group/attachment flex w-72 max-w-full min-w-0 items-center gap-1 rounded-xl border bg-card pr-1 text-card-foreground transition-colors focus-within:ring-1 focus-within:ring-ring/50 hover:bg-muted/50"
  >
    <button
      type="button"
      data-test-id="message-file-link"
      class="flex min-w-0 flex-1 items-center gap-2.5 rounded-xl py-2 pl-2 text-left outline-none"
      :aria-label="t('chat.files.open', { name: file.name })"
      @click="emit('open')"
    >
      <span
        aria-hidden="true"
        class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted text-[0.625rem] font-bold uppercase tracking-wide text-muted-foreground"
        >{{ extensionLabelRef }}</span
      >
      <span class="min-w-0 flex-1 leading-tight">
        <span class="block truncate text-sm font-medium">{{ file.name }}</span>
        <span data-test-id="message-file-description" class="mt-0.5 block truncate text-xs text-muted-foreground">{{
          descriptionRef
        }}</span>
      </span>
    </button>
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      class="shrink-0"
      data-test-id="message-file-download"
      :aria-label="t('chat.files.download', { name: file.name })"
      @click="emit('download')"
    >
      <Download class="size-4" aria-hidden="true" />
    </Button>
  </div>
</template>

<script setup lang="ts">
import { Download } from 'lucide-vue-next'
import { computed } from 'vue'

import { Button } from '@/components/ui/button'
import { formatFileDescription, getExtensionLabel } from '@/features/chat/utils/chat-file-format'
import { useI18n } from '@/lib/i18n'

const props = defineProps<{
  file: { id: string; name: string; ext: string; size?: number | null }
}>()

const emit = defineEmits<{ open: []; download: [] }>()

const { t, locale } = useI18n()

const extensionLabelRef = computed(() => getExtensionLabel(props.file))
const descriptionRef = computed(() =>
  // unites en dur : les traductions passent par une mise en majuscule
  // automatique, qui donnerait « 324 Octets »
  formatFileDescription(
    props.file,
    String(locale.value),
    String(locale.value).startsWith('fr')
      ? { b: 'octets', kb: 'Ko', mb: 'Mo', gb: 'Go' }
      : { b: 'B', kb: 'KB', mb: 'MB', gb: 'GB' },
  ),
)
</script>
